import { Controller } from 'react-hook-form'
import { FormControl, FormHelperText, InputLabel } from '@material-ui/core'
import ReactQuill from 'react-quill'
import { QuillEditor } from '../../components/common/QuillEditor'

export const TextEditor = ({
  control,
  label = null,
  fieldName,
  required = false,
}) => {
  return (
    <Controller
      control={control}
      rules={{ required: required ? 'Ce champ est obligatoire' : false }}
      name={fieldName}
      render={({ field: { onChange, value }, fieldState: { error } }) => {
        return (
          <>
            {label && <InputLabel>{label}</InputLabel>}
            <FormControl error={!!error}>
              <ReactQuill
                value={value}
                onChange={onChange}
                modules={QuillEditor.modules}
              />
              {error && <FormHelperText>{error.message}</FormHelperText>}
            </FormControl>
          </>
        )
      }}
    />
  )
}
